var set = require('regenerate')();

set.addRange(0x1C50, 0x1C7F);
module.exports = set;